import { SmallDown, SmallUp } from 'components/Responsive/breakpoints'
import React, { useMemo } from 'react'
import { defaultCurrencies } from '../../constants'
import {
  formatChargesText,
  getLabelFromValue,
  numberWithCommas,
} from '../../helpers'

const AdditionalCharges = ({ charges, supplierInfo, serviceType }) => {
  const supplierCurrency = useMemo(
    () => getLabelFromValue(defaultCurrencies, supplierInfo.supplierCurrency),
    [supplierInfo.supplierCurrency]
  )
  const buyingPrice = useMemo(
    () => numberWithCommas(parseFloat(supplierInfo.buyingPrice).toFixed(2)),
    [supplierInfo.buyingPrice]
  )
  const totalPrice = useMemo(
    () =>
      numberWithCommas(parseFloat(supplierInfo.totalBuyingPrice).toFixed(2)),
    [supplierInfo.totalBuyingPrice]
  )

  return (
    <>
      <SmallUp>
        <div className='driver-service-card'>
          <div className='driver-service-card-header'>
            <span>
              <img
                className='mr-4'
                src='/images/icons/icon-bookings-black.png'
                width={20}
                alt=''
              />
              Price
            </span>
            <span style={{ paddingRight: '0.9rem' }}>
              {totalPrice} {supplierCurrency}
            </span>
          </div>
          <div className='driver-service-card-body'>
            <div className='driver-service-additionlCharges'>
              <div className='d-flex justify-content-between'>
                <span className='title'>{`${serviceType}`}</span>
                <span>{`${buyingPrice} ${supplierCurrency}`}</span>
              </div>
              <hr />
              {charges.map((item, index) => (
                <>
                  <div className='d-flex justify-content-between'>
                    <span className='title'>{`${formatChargesText(
                      item.description
                    )}`}</span>
                    <span>
                      {`+${numberWithCommas(
                        parseFloat(item.amount).toFixed(2)
                      )} ${supplierCurrency}`}
                    </span>
                  </div>
                  {charges.length !== index + 1 && <hr />}
                </>
              ))}
            </div>
          </div>
        </div>
      </SmallUp>
      <SmallDown>
        <div className='driver-booking-price'>
          <div className='driver-service-card-body' style={{ width: '90%' }}>
            <div className='d-flex justify-content-between pt-2 pb-2'>
              <span className='mb-3'>
                <img
                  className='mr-4'
                  src='/images/icons/icon-bookings-black.png'
                  width={20}
                  alt=''
                />
                {'Price'}
              </span>
              <span style={{ paddingRight: '0.9rem' }}>
                {totalPrice} {supplierCurrency}
              </span>
            </div>
            <div className='driver-service-additionlCharges pb-4 pt-4 mb-3'>
              <div className='d-flex justify-content-between'>
                <span className='title'>{`${serviceType}`}</span>
                <span>{`${buyingPrice} ${supplierCurrency}`}</span>
              </div>
              <hr />
              {charges.map((item, index) => (
                <>
                  <div className='d-flex justify-content-between'>
                    <span className='title'>{`${formatChargesText(
                      item.description
                    )}`}</span>
                    <span>
                      {`+${numberWithCommas(
                        parseFloat(item.amount).toFixed(2)
                      )} ${supplierCurrency}`}
                    </span>
                  </div>
                  {charges.length !== index + 1 && <hr />}
                </>
              ))}
            </div>
          </div>
        </div>
      </SmallDown>
    </>
  )
}

export default AdditionalCharges
